import CustomToolTip from 'components/tooltips';
import React from 'react';
import { MdCheck, MdFileCopy } from "react-icons/md";

const ShortTruncateCopy = ({
  info,
  slice = 50,
  showCopy,
}: {
  info: string;
  slice?: number;
  showCopy?: boolean;
}) => {
  const [copy, setCopy] = React.useState(false);

  const truncatedText =
    info?.length > slice ? info.substring(0, slice) + "..." : info;

  return (
    <div className="flex items-center gap-2">
      {truncatedText}

      {showCopy && (
        copy ? (
          <MdCheck className="cursor-not-allowed text-teal-500" />
        ) : (
          <MdFileCopy
            className="cursor-pointer text-teal-500"
            onClick={() => {
              navigator.clipboard.writeText(info);
              setCopy(true);
              setTimeout(() => setCopy(false), 1500);
            }}
          />
        )
      )}
    </div>
  );
};

export default ShortTruncateCopy;